const updateGymSaving = (state, { payload }) => {
	state.gymSaving = payload;
};

export default updateGymSaving;
